<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";

import { getManufacturers } from "@/service";
import { formatDatetime } from "@/helpers/common";
import _ from 'lodash';
import tableLoading from "@/views/widgets/table-loading";
import ShowAvatar from "@/views/widgets/show-avatar";
import {INDUSTRY_TXT, INDUSTRY} from "@/config/common";
// import {alertComfirm, successMsg} from "@/helpers/swal";
import i18n from "@/i18n";
export default {
  page: {
    title: i18n.global.t('menu.business-partner.manufacturer'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: this.$t('menu.business-partner.manufacturer'),
      items: [{
        text: this.$t('menu.business-partner.text'),
        href: "/",
      },
        {
          text: this.$t('menu.business-partner.manufacturer'),
          active: true,
        },
      ],
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'name',
          label: this.$t('manufacturer.device-manufacturer-name'),
          visible: true
        },
        {
          name: 'industry_txt',
          label: this.$t('page.industry'),
          visible: true
        },
        // {
        //   name: 'contact_name',
        //   label: '联系人',
        //   visible: true
        // },
        {
          name: 'tel',
          label: this.$t('page.contact_number'),
          visible: true
        },
        {
          name: 'email',
          label: this.$t('page.email'),
          visible: true
        },
        {
          name: 'location',
          label: this.$t('page.location'),
          visible: true
        },
        {
          name: 'address',
          label: this.$t('page.detailedAddress'),
          visible: true
        },
      ],
      showAllColumns: [],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 2,
      },
      filter_value: {
        keyword: '',
        industry: null,
      },
      INDUSTRY_TXT,
      INDUSTRY,
    };
  },
  components: {
    Layout,
    // PageHeader,
    Multiselect,
    tableLoading,
    ShowAvatar,
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this._getFirstPage()
  },

  methods: {
    formatDatetime,
    // 设置显示列
    changeShowAllColumns() {
      console.log(this.showAllColumns)
      this.tableHeaders.forEach(i => {
        i.visible = this.showAllColumns
      })
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        industry: null,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.industry) {
        search['industry'] = this.filter_value.industry
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value.keyword = null
      this.filter_value.industry = null
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      this.tableLoading = true
      this.tableLoaded = false
      getManufacturers(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
    // 跳转到权限管理
    goPermission() {
      this.$router.push({
        path: '/permission-management',
        query: {
          type: 'manufacturer'
        }
      })
    },

  },
};
</script>

<template>
  <Layout>
    <!--    <PageHeader :title="title" :items="items" />-->
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{ $t('menu.business-partner.manufacturer') }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <b-button type="button" variant="outline-primary" class="add-btn me-1" v-perm="'admin.permission.get'" @click="goPermission">
                    {{ $t('page.permission-management') }}
                  </b-button>

<!--                  <b-button type="button" variant="primary" class="add-btn" @click="add">-->
<!--                    <i class="ri-add-line align-bottom me-1"></i> 添加-->
<!--                  </b-button>-->
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="5">
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword"
                           :placeholder= "`${$t('manufacturer.device-manufacturer-name')}/${ $t('page.contact_number')}/${$t('page.email')}`" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="5">
                  <div class="input-light">
                    <Multiselect class="form-control" :placeholder="$t('page.select-industry')" v-model="filter_value.industry" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="INDUSTRY" :can-clear="false" />
                  </div>
                </b-col>
<!--                <b-col xxl="2" sm="4">-->
<!--                  <div class="input-light">-->
<!--                    <Multiselect class="form-control" placeholder="请选择位置" v-model="filter_value.status" :close-on-select="true" :searchable="false"-->
<!--                                 :create-option="false" :options="[]" :can-clear="false" />-->
<!--                  </div>-->
<!--                </b-col>-->
                <b-col xxl="2"  class="d-flex justify-content-end align-items-end">
                    <b-button type="button" variant="primary" class="me-2" @click="doFilter">
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{$t('search')}}
                    </b-button>
                    <b-button
                        type="button"
                        variant="info"
                        @click="resetSearch"
                    >
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      {{$t('base.reset')}}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                    <th>
                      {{$t('base.operation')}}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-show="titleItem.visible">
                        <div v-if="titleItem.name === 'name'" class="d-flex align-items-center">
                          <show-avatar :img-src="item.logo" :title="item.name" size="xs" bg-class="bg-soft-info" text-class="text-info" class="me-2"></show-avatar>
                          {{ item[titleItem.name] }}
                        </div>
                        <span v-else-if="titleItem.name === 'location'">
                          {{ item.country_txt }}-{{ item.province_txt }}-{{ item.city_txt }}
                        </span>
                        <span v-else>{{ item[titleItem.name] }}</span>
                      </td>
                    </template>
                    <td>
                      <b-link :href="'/manufacturer/' + item['id']"><i class="ri-eye-fill fs-3 text-primary me-3 cursor-pointer"></i></b-link>
<!--                      <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="deleteItem(item.id)"></i>-->
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loaded="tableLoaded" :table-loading="tableLoading"></table-loading>
              </div>

            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
  </Layout>

</template>
